<template>
  <div class="body">
    <!-- 选项卡 -->
    <div id="top" class="nav-tab" style="position: fixed;top:0;left:0;">
      <div @click="back" class="card_back">
        <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
      </div>
      <ul>
        <li v-for="(item , index) in tabData" :key="index">
          <a href="javascript:;" @click="switchTab(item.path , index)"
            :class="[index === currentIndex ? 'active' : '']">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <div class="nav-tab">

    </div>
    <!-- 模块切换 -->
    <div class="content">
      <keep-alive>
        <component :is='currentView'></component>
      </keep-alive>
    </div>
  </div>
</template>
<script>

// config
import appConfig from '../../appConfig';

// 限时秒杀
import seckill from './seckill'
// 学分
import integral from './integral'
// 9.9好课
import goodLesson from './goodLesson'

// util
import windowHelper from '@util/windowHelper';
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';

export default {
  data () {
    return {
      // 选项卡切换
      tabData: [
        // { path: 'seckill', name: '限时秒杀' },
        { path: 'integral', name: '签到' },
        // { path: 'goodLesson', name: '9.9元好课' },
      ],
      // 当前模块
      currentView: 'integral',

      // 当前索引
      currentIndex: 0,
      isShow: false,
      windowHelper: windowHelper,
      title: '签到'
    }
  },
  components: {
    seckill,
    integral,
    goodLesson


  },
  watch: {
    $route (to, from) {
      // if (to.path === '/operationMain/seckill') {
      //   this.currentView = 'seckill';
      //   this.currentIndex = 0;
      //   this.title = this.tabData[0].name;
      // }

      if (to.path === '/operationMain/integral') {
        this.currentView = 'integral';
        this.currentIndex = 0;
        this.title = this.tabData[0].name;
      }

      // if (to.path === '/operationMain/goodLesson') {
      //   this.currentView = 'goodLesson';
      //   this.currentIndex = 1;
      //   this.title = this.tabData[1].name;
      // }

    }
  },


  created () {
    if (this.$route.params.index) {
      this.currentView = this.$route.params.name;
      this.currentIndex = this.$route.params.index;
    }
    if (this.$route.path === '/operationMain/integral') {
      this.currentView = 'integral';
      this.currentIndex = 1;
      this.title = this.tabData[1].name;
    }

    if (this.$route.path === '/operationMain/goodLesson') {
      this.currentView = 'goodLesson';
      this.currentIndex = 2;
      this.title = this.tabData[2].name;
    }

    appHelper.setTitle(this.title);

    if (deviceHelper.isBrowser && browserHelper.isWechat) {
      this.setWechatShare();
    }
  },

  methods: {
    back () {
      appHelper.back(this)
    },


    switchTab: function (tabText, index) {
      this.currentView = tabText;
      this.currentIndex = index;
      this.title = this.tabData[this.currentIndex].name;
      appHelper.setTitle(this.title);
      if (deviceHelper.isBrowser && browserHelper.isWechat) {
        this.setWechatShare();
      }
      this.$router.push({
        name: 'operationMain' + tabText,
        params: {
          tabText: tabText
        }
      })


    },

    setWechatShare: function () {
      let wechatShareOptions = {
        title: appHelper.getTitle(),
        // desc    : this.desc,
        link: location.href,
        imgUrl: appHelper.getAppIcon() // 分享图标
      };
      wechatHelper.setShare(wechatShareOptions);
    },
  },
  mounted () {

    appHelper.setTitle(this.title);

    if (deviceHelper.isBrowser && browserHelper.isWechat) {
      this.setWechatShare();
    }
  },
}
</script>
<style scoped lang="scss">
.body {
  background: #fff;
}
div,
ul,
li,
input {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  height: 100%;
}

.card_back {
  height: 44px;
  line-height: 55px;
  width: 35px;
  padding-left: 10px;
  box-sizing: border-box;
}

// 选项卡
.nav-tab {
  width: 100%;
  height: 44px;
  left: 4%;
  z-index: 999;
  background: #fff;
  display: flex;
  // margin: 0 auto;
  ul {
    overflow: hidden;
    flex: 1;
    display: flex;
    justify-content: center;
    // margin-left: 3%;
    li {
      list-style: none;
      // float: left;
      margin-right: 20px;
      margin-top: 20px;
      // margin-bottom: 20px;

      a {
        font-size: 14px;
        font-weight: 400;
        line-height: 5px;

        color: #2c2c2c;

        display: block;
      }
      .active {
        font-size: 18px;
        font-weight: 500;
        color: #ff3d38;
      }
      .active:after {
        content: '';

        width: 19px;
        height: 6px;
        // background: #FF6767;
        //
        // border-radius: 3px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAMCAYAAADlPXT9AAAB+UlEQVRIS82Tu2uTYRTGf08uNrUFU3EI0lmEEAjENETToaBicVAEERfFv8C6ObqpiKAuOrgILuINREScRBObzzZtoN4WQbpJxVqo2rTJdySphqTNZ2q84Du98J7zPL/34RzxHxyLxfo0NTX7A0XVi0WjvYR7DiGFWeK6HOf9v2C1dHQj/t5bSEOYTfB5cY8mJ2eWoTKp20gHaiBmH/EtZfRk4vXfBLNEYgPdgftImbqP2SVlneOydH83gf4vKwBKuJUjBMfu6DHlPw1n6UQMf/AhYnOztt3TU2ffclKDqVlQeJW52SvK2ks+Py1wfxeulk4ocAqfRlpoVSi7hzX6/OZ3qIH94LvraWq8ocyw8vl3nYJZJnUa6aRnv2snlHMuVN9rULW0tifj+P2jQKhlo5mBFjAbR3aZr5UHKhTmvExsx8A2pGOgg4g+IOD9aRtR1rnYtH11sHg8TE/XDXza3TaRKqRUAltoqjXWAUGkYHsNZrDKkHJjLxtr60nVwcDH4MAw6Coo0la40wKzM8yXzqpY/LRSYhVUHS6RWE8ouBPZOaQtnXo3p2iLwBWsfF65wrSXpidUQ3J+Mqk4xi6ko4itvwZoc5ge4brXKFWyP5vDljO1FjNLJiN0EQdfFBEBbQILYYogqts5j/EB195Cpahn4y/WottY8w1M4q8NTHF3xAAAAABJRU5ErkJggg==);

        // width: 25px;
        // height: 3px;
        // border-radius: 2px;
        // background: #ff6767;
        display: block;
        margin: 9px auto;
      }
    }
  }
}
</style>
